import { BUSINESS } from "./business";

export const SERVICES = [
  {
    slug: "smog-check-modesto",
    title: "Smog Check",
    title_es: "Prueba de Smog",
    short: "Regular smog check for all vehicles. Fast, reliable and DMV approved.",
    short_es: "Prueba de smog regular para todos los vehículos. Rápida, confiable y aprobada por el DMV.",
    keyword: "Smog Check Modesto CA",
    intro:
      "A fast, state-certified smog inspection for cars, minivans, trucks and motorhomes in Modesto. Most tests are done in 15–20 minutes and results are submitted to the DMV electronically.",
    intro_es:
      "Una inspección de smog certificada por el estado, rápida, para autos, minivans, camionetas y casas rodantes en Modesto. La mayoría de las pruebas se hacen en 15–20 minutos y los resultados se envían al DMV electrónicamente.",
    included: [
      "Full OBD-II & visual emissions inspection",
      "Electronic results sent directly to the DMV",
      "Same clear price — no upcharge for SUVs, trucks or vans",
      "Walk-ins welcome, no appointment needed",
    ],
    included_es: [
      "Inspección completa OBD-II y visual de emisiones",
      "Resultados electrónicos enviados directamente al DMV",
      "Mismo precio claro — sin recargo para SUVs, camionetas o vans",
      "Sin cita — atendemos sin necesidad de reservación",
    ],
    body:
      "Whether you need a smog check for registration renewal, a change of ownership, or an out-of-state vehicle, Smog Hut Modesto has you covered. Our certified technicians use the latest testing equipment to get accurate results the first time. If your vehicle passes, we submit the certificate electronically so you can renew with the DMV right away.",
    body_es:
      "Ya sea que necesite una prueba de smog para renovar su registro, un cambio de dueño o un vehículo de fuera del estado, Smog Hut Modesto lo tiene cubierto. Nuestros técnicos certificados usan el equipo más moderno para obtener resultados precisos la primera vez. Si su vehículo pasa, enviamos el certificado electrónicamente para que renueve con el DMV de inmediato.",
  },
  {
    slug: "star-smog-check-modesto",
    title: "STAR Smog Check",
    title_es: "Prueba de Smog STAR",
    short: "STAR certified smog check for vehicles that require a STAR station.",
    short_es: "Prueba de smog certificada STAR para vehículos que requieren una estación STAR.",
    keyword: "STAR Smog Check Modesto CA",
    intro:
      "If your DMV renewal notice says \u201cSmog Certification Required at STAR Station,\u201d you're in the right place. Smog Hut Modesto is a state-directed STAR certified station.",
    intro_es:
      "Si su aviso de renovación del DMV dice \u201cSmog Certification Required at STAR Station\u201d, está en el lugar correcto. Smog Hut Modesto es una estación certificada STAR dirigida por el estado.",
    included: [
      "DMV-directed STAR station certification",
      "Meets Bureau of Automotive Repair (BAR) standards",
      "Gross polluter certification available",
      "Results submitted electronically",
    ],
    included_es: [
      "Certificación de estación STAR dirigida por el DMV",
      "Cumple con los estándares del Bureau of Automotive Repair (BAR)",
      "Certificación de gross polluter disponible",
      "Resultados enviados electrónicamente",
    ],
    body:
      "STAR stations are held to higher performance standards set by the California Bureau of Automotive Repair. When the DMV directs your vehicle to a STAR station, we can complete the inspection and certification on the spot — no need to visit a second shop.",
    body_es:
      "Las estaciones STAR cumplen con estándares de desempeño más altos establecidos por el Bureau of Automotive Repair de California. Cuando el DMV dirige su vehículo a una estación STAR, podemos completar la inspección y la certificación en el momento — sin necesidad de visitar otro taller.",
  },
  {
    slug: "diesel-smog-check-modesto",
    title: "Diesel Smog Check",
    title_es: "Smog de Diésel",
    short: "Diesel emissions testing to keep your diesel vehicle compliant.",
    short_es: "Prueba de emisiones diésel para mantener su vehículo diésel en cumplimiento.",
    keyword: "Diesel Smog Check Modesto CA",
    intro:
      "We perform diesel smog checks and emissions testing for qualifying diesel vehicles in Modesto and Ceres using advanced diesel-ready equipment.",
    intro_es:
      "Realizamos pruebas de smog y emisiones para vehículos diésel que califican en Modesto y Ceres usando equipo avanzado para diésel.",
    included: [
      "Diesel emissions inspection",
      "Advanced diesel testing equipment",
      "Certified diesel smog technicians",
      "Fast electronic DMV submission",
    ],
    included_es: [
      "Inspección de emisiones diésel",
      "Equipo avanzado para pruebas diésel",
      "Técnicos certificados en smog diésel",
      "Envío electrónico rápido al DMV",
    ],
    body:
      "California requires many diesel vehicles to complete a smog inspection for registration. Our technicians are trained and equipped to test diesel vehicles quickly and accurately so you can stay compliant and on the road.",
    body_es:
      "California requiere que muchos vehículos diésel completen una inspección de smog para el registro. Nuestros técnicos están capacitados y equipados para probar vehículos diésel de forma rápida y precisa para que siga en cumplimiento y en el camino.",
  },
  {
    slug: "smog-repair-modesto",
    title: "Smog Repairs",
    title_es: "Reparaciones de Smog",
    short: "Failed your test? Honest diagnostics and smog-related repairs.",
    short_es: "¿No pasó la prueba? Diagnóstico honesto y reparaciones relacionadas con el smog.",
    keyword: "Smog Repair Modesto CA",
    intro:
      "As a licensed Test & Repair station, we don't just test — we can help diagnose and repair the issues that cause a smog failure, then retest your vehicle.",
    intro_es:
      "Como estación licenciada de Prueba y Reparación, no solo probamos — ayudamos a diagnosticar y reparar los problemas que causan una falla de smog, y luego volvemos a probar su vehículo.",
    included: [
      "Honest diagnostics for smog failures",
      "Emissions-related repairs",
      "90-day free retest policy",
      "Guidance on the Consumer Assistance Program (CAP)",
    ],
    included_es: [
      "Diagnóstico honesto de fallas de smog",
      "Reparaciones relacionadas con emisiones",
      "Política de reprueba gratis por 90 días",
      "Orientación sobre el Consumer Assistance Program (CAP)",
    ],
    body:
      "If your vehicle fails, we'll explain exactly why in plain language and walk you through your options — including possible financial assistance through the state's Consumer Assistance Program. Once repairs are complete, we retest to get you certified.",
    body_es:
      "Si su vehículo no pasa, le explicaremos exactamente por qué en un lenguaje sencillo y le guiaremos por sus opciones — incluyendo posible ayuda económica a través del Consumer Assistance Program del estado. Una vez completadas las reparaciones, volvemos a probar para certificarlo.",
  },
  {
    slug: "registration-renewal-modesto",
    title: "Registration & Tags",
    title_es: "Registro y Placas",
    short: "Skip the DMV lines — renew your registration and walk out with tags.",
    short_es: "Evite las filas del DMV — renueve su registro y salga con sus placas.",
    keyword: "DMV Registration Renewal Modesto CA",
    intro:
      "Don't waste hours at the DMV. Along with your smog check, we can renew your registration and hand you new stickers on the spot.",
    intro_es:
      "No pierda horas en el DMV. Junto con su prueba de smog, podemos renovar su registro y entregarle las nuevas calcomanías en el momento.",
    included: [
      "Registration renewal processing",
      "New tags/stickers in hand same visit",
      "No long DMV waits",
      "Friendly, fast service",
    ],
    included_es: [
      "Procesamiento de renovación de registro",
      "Nuevas placas/calcomanías en la misma visita",
      "Sin largas esperas en el DMV",
      "Servicio amable y rápido",
    ],
    body:
      "We're a licensed registration service. That means we handle the paperwork and issue your current registration and new tags right here — no separate trip to the DMV required.",
    body_es:
      "Somos un servicio de registro licenciado. Eso significa que manejamos el papeleo y emitimos su registro actual y nuevas placas aquí mismo — sin necesidad de un viaje aparte al DMV.",
  },
  {
    slug: "title-transfer-modesto",
    title: "Title Transfer",
    title_es: "Transferencia de Título",
    short: "Buying or selling? We handle change-of-ownership transfers.",
    short_es: "¿Comprando o vendiendo? Realizamos transferencias por cambio de dueño.",
    keyword: "Title Transfer Modesto CA",
    intro:
      "Just bought or sold a vehicle? We process title transfers and change-of-ownership paperwork so ownership is updated correctly and quickly.",
    intro_es:
      "¿Acaba de comprar o vender un vehículo? Procesamos transferencias de título y el papeleo de cambio de dueño para que la propiedad se actualice correcta y rápidamente.",
    included: [
      "Change of ownership processing",
      "Title transfer paperwork handled",
      "Out-of-state vehicle assistance",
      "Combine with smog check in one visit",
    ],
    included_es: [
      "Procesamiento de cambio de dueño",
      "Manejo del papeleo de transferencia de título",
      "Asistencia para vehículos de fuera del estado",
      "Combine con la prueba de smog en una sola visita",
    ],
    body:
      "Transferring a title can be confusing. Our staff handles the forms and fees for you and can combine the transfer with any required smog check so everything is done in a single visit.",
    body_es:
      "Transferir un título puede ser confuso. Nuestro personal maneja los formularios y las tarifas por usted y puede combinar la transferencia con cualquier prueba de smog requerida para que todo se haga en una sola visita.",
  },
];

export const FAQS = [
  {
    q: "Do I need an appointment for a smog check?",
    q_es: "¿Necesito cita para una prueba de smog?",
    a: "No appointment is necessary. Smog Hut Modesto welcomes walk-ins Monday through Saturday — just drive up to 1455 Herndon Rd #3 in Modesto and we'll get you tested, usually in 15–20 minutes.",
    a_es: "No se necesita cita. Smog Hut Modesto atiende sin cita de lunes a sábado — solo llegue al 1455 Herndon Rd #3 en Modesto y lo atenderemos, normalmente en 15–20 minutos.",
  },
  {
    q: "How long does a smog check take?",
    q_es: "¿Cuánto tarda una prueba de smog?",
    a: "Most smog checks are completed in about 15–20 minutes. We have a comfortable waiting room where you can relax while we certify your vehicle.",
    a_es: "La mayoría de las pruebas se completan en unos 15–20 minutos. Tenemos una cómoda sala de espera donde puede relajarse mientras certificamos su vehículo.",
  },
  {
    q: "My DMV notice says I need a STAR smog check. Can you do it?",
    q_es: "Mi aviso del DMV dice que necesito una prueba STAR. ¿La pueden hacer?",
    a: "Yes. Smog Hut Modesto is a state-directed STAR certified station, so we can complete STAR-directed inspections and certifications on the spot.",
    a_es: "Sí. Smog Hut Modesto es una estación certificada STAR dirigida por el estado, así que podemos completar inspecciones y certificaciones STAR en el momento.",
  },
  {
    q: "Do you smog check diesel vehicles?",
    q_es: "¿Hacen pruebas de smog a vehículos diésel?",
    a: "Yes. We're equipped to perform diesel smog checks and emissions testing for qualifying diesel vehicles.",
    a_es: "Sí. Estamos equipados para realizar pruebas de smog y emisiones a vehículos diésel que califican.",
  },
  {
    q: "Can you renew my registration and give me tags?",
    q_es: "¿Pueden renovar mi registro y darme las placas?",
    a: "Absolutely. We're a licensed registration service — skip the DMV lines and walk out with your current registration and new stickers in hand.",
    a_es: "Por supuesto. Somos un servicio de registro licenciado — evite las filas del DMV y salga con su registro actual y nuevas calcomanías en mano.",
  },
  {
    q: "What happens if my vehicle fails the smog check?",
    q_es: "¿Qué pasa si mi vehículo no pasa la prueba de smog?",
    a: "We'll explain why it failed in plain language. As a licensed Test & Repair station we can perform the needed repairs, and we offer a 90-day free retest so you have peace of mind.",
    a_es: "Le explicaremos por qué no pasó en un lenguaje sencillo. Como estación licenciada de Prueba y Reparación podemos realizar las reparaciones necesarias, y ofrecemos una reprueba gratis por 90 días para su tranquilidad.",
  },
  {
    q: "How much does a smog check cost in Modesto?",
    q_es: "¿Cuánto cuesta una prueba de smog en Modesto?",
    a: "Our pricing is clear with no surprise upcharges for SUVs, trucks or Star-certified vehicles. See our Pricing page for current rates, and don't forget to mention our $20 OFF coupon.",
    a_es: "Nuestros precios son claros, sin recargos sorpresa para SUVs, camionetas o vehículos STAR. Vea nuestra página de Precios para las tarifas actuales, y no olvide mencionar nuestro cupón de $20 de descuento.",
  },
];

export const PROCESS = [
  { title: "Visit Us", title_es: "Visítenos", text: `Come to our shop at ${BUSINESS.address.full}.`, text_es: `Venga a nuestro taller en ${BUSINESS.address.full}.` },
  { title: "Inspection", title_es: "Inspección", text: "We perform a visual inspection of your vehicle.", text_es: "Realizamos una inspección visual de su vehículo." },
  { title: "Smog Test", title_es: "Prueba de Smog", text: "We run the official smog test on state equipment.", text_es: "Ejecutamos la prueba oficial de smog con equipo del estado." },
  { title: "Results", title_es: "Resultados", text: "You receive your results immediately.", text_es: "Recibe sus resultados de inmediato." },
  { title: "Confirmation", title_es: "Confirmación", text: "We electronically submit your results — done.", text_es: "Enviamos sus resultados electrónicamente — listo." },
];

export const CITY_CONTENT = {
  modesto: {
    name: "Modesto",
    primary: true,
    intro:
      "Smog Hut Modesto is conveniently located at 1455 Herndon Rd #3, just off the Herndon/Hatch area near Highway 99. We're the go-to STAR smog station for Modesto drivers who want fast, honest service without the DMV headache.",
    intro_es:
      "Smog Hut Modesto está convenientemente ubicado en 1455 Herndon Rd #3, cerca del área de Herndon/Hatch junto a la Highway 99. Somos la estación STAR preferida por los conductores de Modesto que quieren un servicio rápido y honesto sin el dolor de cabeza del DMV.",
    roads: ["Highway 99", "Herndon Rd", "Crows Landing Rd", "Hatch Rd"],
    drive: "Central Modesto and nearby neighborhoods are just minutes away.",
    drive_es: "El centro de Modesto y los vecindarios cercanos están a solo minutos.",
  },
  ceres: {
    name: "Ceres",
    intro:
      "Ceres drivers trust Smog Hut Modesto for quick STAR smog checks and registration services. We're a short drive up Highway 99 from downtown Ceres.",
    intro_es:
      "Los conductores de Ceres confían en Smog Hut Modesto para pruebas STAR rápidas y servicios de registro. Estamos a corta distancia por la Highway 99 desde el centro de Ceres.",
    roads: ["Highway 99", "Mitchell Rd", "Hatch Rd", "Whitmore Ave"],
    drive: "About 8–10 minutes from central Ceres via Highway 99.",
    drive_es: "Alrededor de 8–10 minutos del centro de Ceres por la Highway 99.",
  },
  turlock: {
    name: "Turlock",
    intro:
      "Serving Turlock with fast, STAR-certified smog checks. Skip the local wait and get in-and-out in about 15–20 minutes at our Modesto station.",
    intro_es:
      "Atendemos a Turlock con pruebas de smog rápidas y certificadas STAR. Evite la espera local y entre y salga en unos 15–20 minutos en nuestra estación de Modesto.",
    roads: ["Highway 99", "Golden State Blvd", "Countryside Dr"],
    drive: "Roughly 20 minutes north of Turlock via Highway 99.",
    drive_es: "Aproximadamente 20 minutos al norte de Turlock por la Highway 99.",
  },
  riverbank: {
    name: "Riverbank",
    intro:
      "Riverbank residents are welcome at Smog Hut Modesto for smog checks, diesel testing and DMV registration renewals — all in one visit.",
    intro_es:
      "Los residentes de Riverbank son bienvenidos en Smog Hut Modesto para pruebas de smog, pruebas diésel y renovaciones de registro del DMV — todo en una sola visita.",
    roads: ["Claus Rd", "Oakdale Rd", "Highway 108"],
    drive: "About 15 minutes from Riverbank.",
    drive_es: "Alrededor de 15 minutos desde Riverbank.",
  },
  salida: {
    name: "Salida",
    intro:
      "Salida drivers get quick, walk-in smog checks and tag renewals at our nearby Modesto location just off Highway 99.",
    intro_es:
      "Los conductores de Salida obtienen pruebas de smog sin cita y renovaciones de placas en nuestra ubicación cercana de Modesto, junto a la Highway 99.",
    roads: ["Highway 99", "Kiernan Ave", "Sisk Rd"],
    drive: "Approximately 15 minutes south of Salida.",
    drive_es: "Aproximadamente 15 minutos al sur de Salida.",
  },
  hughson: {
    name: "Hughson",
    intro:
      "Hughson customers rely on Smog Hut Modesto for honest smog testing and repairs with a 90-day free retest guarantee.",
    intro_es:
      "Los clientes de Hughson confían en Smog Hut Modesto para pruebas y reparaciones de smog honestas con garantía de reprueba gratis por 90 días.",
    roads: ["Highway 99", "Hatch Rd", "Whitmore Ave"],
    drive: "About 15–20 minutes from Hughson.",
    drive_es: "Alrededor de 15–20 minutos desde Hughson.",
  },
};
